import GradientContainer from "@app/components/gradient/gradient-container"

const DesktopIndustriesGradient = () => {
  return (
    <div className="w-full">
      <GradientContainer overrideClassName="px-40 py-16 space-y-2 flex flex-col items-center justify-center">
        <p className="h1 text-light">
          Diversity
        </p>
        <p className="subheading text-light">
          Representing clients in every industry.
        </p>
      </GradientContainer>
    </div>
  )
}

export default DesktopIndustriesGradient;
